import { render, staticRenderFns } from "./student-manage.vue?vue&type=template&id=53b52fed&scoped=true"
import script from "./student-manage.vue?vue&type=script&lang=js"
export * from "./student-manage.vue?vue&type=script&lang=js"
import style0 from "./student-manage.vue?vue&type=style&index=0&id=53b52fed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b52fed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b52fed')) {
      api.createRecord('53b52fed', component.options)
    } else {
      api.reload('53b52fed', component.options)
    }
    module.hot.accept("./student-manage.vue?vue&type=template&id=53b52fed&scoped=true", function () {
      api.rerender('53b52fed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/student-manage.vue"
export default component.exports